<div class="mx-auto gap-4 page-wrapper">
  @for (brand of brands; track brand.id) {
    <button type="button" class="box-sizing-border-box flex-1 brand" (click)="onBrandClick(brand)">
      <img [src]="brand.image" class="image-replacer" alt="" loading="lazy" />
      <p class="paragraph-medium font-medium text-center">{{ brand.name }}</p>
    </button>
  }
</div>
